export const ANALYSIS_FINDING_SEVERITY_VALUES = {
  info: 'info',
  warning: 'warning',
  critical: 'critical',
} as const;

export type AnalysisFindingSeverity =
  (typeof ANALYSIS_FINDING_SEVERITY_VALUES)[keyof typeof ANALYSIS_FINDING_SEVERITY_VALUES];

export const ANALYSIS_FINDING_DECISION_VALUES = {
  pending: 'pending',
  accepted: 'accepted',
  dismissed: 'dismissed',
} as const;

export type AnalysisFindingDecision =
  (typeof ANALYSIS_FINDING_DECISION_VALUES)[keyof typeof ANALYSIS_FINDING_DECISION_VALUES];
